var _linearGradient, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImtoken = function SvgImtoken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(23.9866 0 0 -16.946 6597.1353 5695.4907)",
    gradientUnits: "userSpaceOnUse",
    x1: -272.5272,
    x2: -275.1207,
    y1: 335.5532,
    y2: 332.9597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11c4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062ad"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m63.8 10.9c2.1 28.6-16.2 42.1-32.7 43.6-15.3 1.3-29.7-8.1-31-22.5-1-11.9 6.3-17 12.1-17.5 6-.5 11 3.6 11.4 8.6.4 4.8-2.6 7-4.6 7.2-1.6.1-3.7-.9-3.9-3-.2-1.8.5-2.1.4-4-.3-3.5-3.3-3.9-5-3.7-2 .2-5.7 2.5-5.1 8.4.5 5.9 6.2 10.6 13.6 9.9 8-.7 13.6-6.9 14-15.7 0-.5.1-.9.3-1.3.1-.2.2-.4.3-.5.2-.3.4-.5.7-.8.2-.2.5-.5.7-.8 3.5-3.3 16.1-11.1 28-8.6.4-.2.8.2.8.7",
    fill: "url(#a)"
  })));
};

export { SvgImtoken as ReactComponent };
export default __webpack_public_path__ + "0238123cef21b3ef524be5be3690f58b.svg";